import { NgModule } from 'ng-metadata/core';
import {PrmMainMenu} from './mainMenu/mainMenu.directive';
import {MobileMenu} from './menu.service';
import {PrmSkipTo} from './skipTo/skipTo.directive';
import {SkipToService} from './skipTo/skipTo.service';
import {QrCodeService} from './qrCode/qrCode.service';
import {PrmQrCode} from './qrCode/qrCode.directive';
import {PrmLogo} from './logo/logo.directive';
import {PrmSearchBookmarkFilter} from './bookmarkFilter/searchBookmarkFilter.directive';
import {UserAreaModule} from './userArea/userArea.module';
import {PrmTopbar} from './topbar.directive';
import {CollectionGalleryService} from "../../collectionDiscovery/collectionGallery/collectionGallery.service";

@NgModule({
    declarations: [
        PrmLogo,
        PrmMainMenu,
        PrmSearchBookmarkFilter,
        PrmSkipTo,
        PrmTopbar,
        PrmQrCode
    ],
    providers: [
        MobileMenu,
        SkipToService,
        QrCodeService,
        CollectionGalleryService
    ],
    imports:[
        UserAreaModule
    ]
})
export class TopbarModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/topbar.module.ts